export default "__VITE_ASSET__BxqslHMJ__"